// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.comment-input .comment-input-footer {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.comment-input textarea.m-input.with-overflow {\n  height: 92px;\n  min-height: 92px;\n}\n", ""]);
// Exports
module.exports = exports;
